import React from 'react';

import styles from './sortable_header.module.css';

const ARIA_SORT = { asc: 'ascending', desc: 'descending' };

export default function SortableHeader({ column, label, sortColumn, sortDirection, onSort }) {
  // Keyword / Mentor Report is free text, so it is not a button and never shows an indicator.
  if (!column.sortKey) {
    return (
      <th className={styles.header} scope='col'>
        {label}
      </th>
    );
  }

  const isSorted = sortColumn === column.sortKey;

  return (
    <th aria-sort={isSorted ? ARIA_SORT[sortDirection] : 'none'} className={styles.header} scope='col'>
      <button
        className={isSorted ? `${styles.button} ${styles.sorted}` : styles.button}
        onClick={() => onSort(column)}
        type='button'
      >
        {label}
        <span aria-hidden='true' className={styles.triangles}>
          <span className={isSorted && sortDirection === 'asc' ? styles.triangle_active : styles.triangle_inactive}>
            ▲
          </span>
          <span className={isSorted && sortDirection === 'desc' ? styles.triangle_active : styles.triangle_inactive}>
            ▼
          </span>
        </span>
      </button>
    </th>
  );
}
